module.exports = __webpack_public_path__ + "static/782811_orig-d17c9a6645dd957096243fcb049faa2c.jpg";